// Gallery.js
import React, { useState, useEffect } from 'react';
import './Gallery.css';

const Gallery = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const galleryItems = [
        {
            id: 1,
            image: '/images/gallery/gallery_1.png',
            title: 'Early Journey & Lasting Impact',
            description: 'Capturing the beginnings at Sanmar Industries alongside a treasured student message — a gentle portrayal of how her path moved from early career foundations to becoming a teacher who touched lives.'
        },

        // {
        //     id: 2,
        //     image: '/images/gallery/gallery_2.png',
        //     title: 'Incredible Teacher Award – National Honour',
        //     description: 'Captured on stage receiving the prestigious “Incredible Teacher: Shaping the Bright Future of Students” award by Oswal Books—an honour based on nationwide student feedback and recognition.'
        // },
        {
            id: 3,
            image: '/images/gallery/gallery_3.png',
            title: 'A Moment of Pride',
            description: 'A graceful portrait with “Incredible Teacher: Shaping the Bright Future of Students” award by Oswal Books',
             link: {
                    text: 'View Oswal Top 50 Teachers Recognition ',
                    url: 'https://share.google/expvYXIK8zdnruQa0'
                }
        
        }
        // ,
        // {
        //     id: 4,
        //     image: '/images/gallery/gallery_4.png',
        //     title: 'A Farewell Filled With Love',
        //     description: 'An emotional school farewell capturing the affection, respect, and unbreakable bond shared with her students—proof that teaching is not just a profession, but a relationship built from the heart.'
        // }
    ];

    const nextSlide = () => {
        setActiveIndex((prev) => (prev + 1) % galleryItems.length);
    };

    const prevSlide = () => {
        setActiveIndex((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);
    };

    const goToSlide = (index) => {
        if (index === activeIndex) return;
        setActiveIndex(index);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % galleryItems.length); 
        }, 20000);

        return () => clearInterval(interval);
    }, [galleryItems.length]);

    return (
        <section id="gallery" className="gallery-section">
            <div className="container">
                <div className="gallery-header">
                    <h2 className="section-title">Professional Journey</h2> 
                    <p className="section-subtitle">
                        A story of excellence, recognition, and meaningful student connections
                    </p>
                </div>

                <div className="gallery-container">
                    <div className="gallery-main">
                        <div className="gallery-track">
                            {galleryItems.map((item, index) => (
                                <div
                                    key={item.id}
                                    className={`gallery-slide ${
                                        index === activeIndex ? 'active' : ''
                                    }`}
                                >
                                    <div className="slide-image-section">
                                        <div className="image-wrapper">
                                            <div className="image-fallback">
                                                <span>Image</span>
                                            </div>
                                            <img 
                                                src={item.image} 
                                                alt={item.title}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.previousSibling.style.display = 'flex';
                                                }}
                                            />
                                        </div>
                                        <div className="image-nav-buttons">
                                            <button className="nav-btn prev-btn" onClick={prevSlide} aria-label="Previous slide">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </button>
                                            <button className="nav-btn next-btn" onClick={nextSlide} aria-label="Next slide">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="slide-content">
                                        <div className="content-wrapper">
                                            <h3 className="slide-title">{item.title}</h3>
                                            <p className="slide-description">{item.description}</p>
                                                {item.link && (
                                                    <a
                                                        href={item.link.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="slide-link"
                                                    >
                                                        {item.link.text}
                                                    </a>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="gallery-thumbnails">
                        {galleryItems.map((item, index) => (
                            <div
                                key={item.id}
                                className={`thumbnail-item ${index === activeIndex ? 'active' : ''}`}
                                onClick={() => goToSlide(index)}
                                role="button"
                                tabIndex="0"
                                aria-label={`Go to slide ${index + 1}: ${item.title}`}
                            >
                                <div className="thumbnail-image">
                                    <div className="thumbnail-fallback"></div>
                                    <img 
                                        src={item.image} 
                                        alt={item.title}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.previousSibling.style.display = 'block';
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gallery;
